import { Icon, IconProps } from "./Icon";

export function IconGrill(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M11.89 3.23A6.92 6.92 0 0 0 13 0h-1a6.25 6.25 0 0 1-1 2.79A6.79 6.79 0 0 0 10 6h1a6 6 0 0 1 .89-2.77ZM22 9h-2.12A8.29 8.29 0 0 0 20 7.51V7h-6a8.66 8.66 0 0 1 .77-1.88A6.53 6.53 0 0 0 16 2h-1a5.84 5.84 0 0 1-1.1 2.68A8.32 8.32 0 0 0 13 7H7a8.7 8.7 0 0 1 .78-1.88A6.63 6.63 0 0 0 9 2H8a5.94 5.94 0 0 1-1.09 2.69A8.65 8.65 0 0 0 6 7H2v.5a8.92 8.92 0 0 0 7 8.65L5 24h1.08l1.06-2h7.73l1 2H17l-4-7.82A9 9 0 0 0 19.66 10H22Zm-7.63 12H7.62L10 16.35c.34 0 .68.06 1 .06s.65 0 1-.05ZM11 15.42A8 8 0 0 1 3 8h16a7.94 7.94 0 0 1-8 7.42Z" />
    </Icon>
  );
}
